<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" />
	<!-- <van-field v-else>
		<template #input> -->
	<van-stepper v-else v-model="value" :disabled="disabled" class="input-number" theme="round" button-size="22" />
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: number | string | null;
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue === 0 ? 0 : props.modelValue ? +props.modelValue : undefined;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.input-number {
		width: 100%;
	}
</style>
